import {UpsellDeclineTextBlock} from '.'

export const createUpsellDeclineTextBlock = (): UpsellDeclineTextBlock => ({
  type: 'UpsellDeclineText',
  visibility: 'all',
  background: {
    image: '',
    color: '',
    opacity: 0,
  },
  padding: {
    top: 10,
    right: 10,
    bottom: 10,
    left: 10,
  },
  alignment: {
    vertical: 'center',
    horizontal: 'center',
  },
  border: {
    width: 0,
    color: '#FFFFFF',
    radius: 0,
  },
  text: 'No, Thank You!',
  font: null,
  fontSize: 20,
  color: '#3490DC',
  opacity: 100,
  lineHeight: 100,
  letterSpacing: 0,
})
